import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Chat from './pages/Chat';
import MetaChat from './pages/MetaChat';
import Projects from './pages/Projects';
import FileManager from './pages/FileManager';
import ProjectWorkspace from './pages/ProjectWorkspace';
import AgentManager from './pages/AgentManager';
import SSHConnections from './pages/SSHConnections';
import Settings from './pages/Settings';
import Login from './pages/Login';
import { Toaster } from 'sonner';
import { Menu, X } from 'lucide-react';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem('auth_token') !== null
  );
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  if (!isAuthenticated) {
    return (
      <Router>
        <Routes>
          <Route path="/login" element={<Login setAuth={setIsAuthenticated} />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
        <Toaster position="top-right" />
      </Router>
    );
  }

  return (
    <Router>
      <div className="app-container">
        {/* Mobile Header with Burger Menu */}
        <div className="mobile-header">
          <button 
            onClick={toggleMobileMenu}
            className="burger-menu-btn"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
          <h1 className="mobile-title">AI Agents</h1>
        </div>

        {/* Overlay for mobile menu */}
        {isMobileMenuOpen && (
          <div 
            className="mobile-overlay"
            onClick={closeMobileMenu}
          />
        )}

        {/* Sidebar */}
        <Sidebar 
          setAuth={setIsAuthenticated}
          isMobileOpen={isMobileMenuOpen}
          closeMobileMenu={closeMobileMenu}
        />

        {/* Main Content */}
        <div className="main-content">
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/meta-chat" element={<MetaChat />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/files/:projectId" element={<FileManager />} />
            <Route path="/project/:projectId" element={<ProjectWorkspace />} />
            <Route path="/agents" element={<AgentManager />} />
            <Route path="/ssh" element={<SSHConnections />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </div>

        <Toaster position="top-right" />
      </div>
    </Router>
  );
}

export default App;
